import { useState } from "react";
import FileContext from "./Context";

const FileContextProvider = ({ children }) => {
  const [capturedImages360, setCapturedImages360] = useState([]);
  const [capturedImageWindshield, setCapturedImageWindshield] = useState([]);
  const [capturedChassisRC, setCapturedChassisRC] = useState([]);
  const [capturedRegNo, setCapturedRegNo] = useState([]);
  const [capturedOdometer,setCapturedOdometer]=useState([]);
  const [capturedTyres,setCapturedTyres]=useState([]);
  const [capturedInspectionImages, setCapturedInspectionImages] = useState([]);
  const [capturedVideo,setCapturedVideo] =useState(null);
  const [odometerVideo,setOdometerVideo]=useState(null);
  const [carView,setCarView]=useState(null);
  const [isBack,setIsBack]=useState(0);
  
  return (
    <FileContext.Provider
      value={{
        capturedImages360,
        setCapturedImages360,
        capturedImageWindshield,
        setCapturedImageWindshield,
        capturedChassisRC,
        setCapturedChassisRC,
        capturedRegNo,
        setCapturedRegNo,
        capturedOdometer,
        setCapturedOdometer,
        capturedTyres,
        setCapturedTyres,
        isBack,
        setIsBack,
        capturedInspectionImages,
        setCapturedInspectionImages,
        capturedVideo,
        setCapturedVideo,
        odometerVideo,
        setOdometerVideo,
        carView,
        setCarView
      }}
    >
      {children}
    </FileContext.Provider>
  );
};

export default FileContextProvider;